export const NO_MARK_THRESHOLD = 6.57;
export const NO_CHANGE_THRESHOLD = -0.57;
